<template>
  <div class="myApplication-list">
    <gtable-crud
      ref="gtable-crud"
      :data="data"
      :option="option"
      :page="page"
      :loading="loading"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @refresh-change="refreshChange"
    >
      <template slot="menuLeft" slot-scope="{ row }">
        <my-tooltip :tooltip="$t('_components.btns.view')">
          <feather-icon
            icon="SearchIcon"
            class="text-warning cursor-pointer ml-1"
            size="20"
            @click="handleStepChange(row)"
          />
        </my-tooltip>
      </template>

      <!-- 自定义列 -->
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'assigneeName'">
          <b-button
            v-if="
              props.row.assigneeName &&
                props.row.assigneeName.split(',').length > 2
            "
            v-b-popover.hover.right="props.row.assigneeName"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            title="Approver"
            variant="flat-primary"
          >
            {{ props.row.assigneeName.split(',')[0] }}...
          </b-button>
          <span v-else-if="props.row.assigneeName">
            {{ props.row.assigneeName }}
          </span>
        </span>
      </template>
    </gtable-crud>
    <!-- 提交面试结果或者View页面 -->
    <c-drawer v-model="drawerShow" :before-close="handleBeforeClose">
      <component
        :is="stepMethodKey"
        v-if="drawerShow"
        v-bind="componentParams"
        @close="handleDrawerClose"
      />
    </c-drawer>
  </div>
</template>

<script>
import { BButton, VBPopover } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'
import applyAPI from '@/api/apply/index'
import CDrawer from '@/components/drawer.vue'
import viewPage from '@/views/apply/components/viewPage.vue'
import workerView from '@/views/worker/apply/components/view.vue'
import components from '@/config/processOption'
import { deepClone } from '@/util/util'

export default {
  components: {
    BButton,
    CDrawer,
    viewPage,
    workerView,
    ...components,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      data: [],
      loading: false,

      rowData: {},
      drawerShow: false,
      formId: '',
      processId: '',
      stepMethodKey: '',
      componentParams: {},
    }
  },
  computed: {
    ...mapGetters(['templateForm']),
    option() {
      const columns = [
        {
          label: this.i18n('formId'),
          field: 'formId',
          dictField: 'formName',
          type: 'select',
          dictCode: 'staffTemplateForm',
          search: true,
          searchBase: true,
        },
        {
          label: this.i18n('createUser'),
          field: 'createUserName',
        },
        {
          label: this.i18n('applicationTime'),
          field: 'createTime',
          type: 'dateRange',
        },
        {
          label: this.i18n('lastApprovalTime'),
          field: 'lastApprovalTime',
        },
        {
          label: this.i18n('assigneeName'),
          field: 'assigneeName',
          slot: true,
        },
        {
          label: this.i18n('taskName'),
          field: 'taskName',
        },
        {
          label: this.i18n('status'),
          field: 'status',
          type: 'select',
          dictBizCode: 'process_status',
          dictField: 'statusName',
          search: true,
          searchBase: true,
        },
      ]
      return {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns,
      }
    },
    templateFormDict() {
      const res = this.templateForm.map((o) => ({
        label: o.formName,
        value: Number(o.id),
      }))
      return res
    },
  },
  mounted() {
    this.onLoad(this.page)
  },
  methods: {
    i18n(param) {
      return this.$t(`_apply.${param}`)
    },
    async onLoad(page, params = {}) {
      this.loading = true
      const res = await applyAPI.getMyApplicationByStaff(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query, this.searchQuery)
      )
      const { data } = res.data
      this.page.total = data.total

      const result = []
      data.records.forEach((item) => {
        const p = item
        item.createTime = this.formatTableDate(item.createTime)
        p.approvalTime = this.formatTableDate(item.bladeFlow.createTime)
        p.taskName = item.bladeFlow.taskName
        p.lastApprovalTime = this.formatTableDate(
          item.bladeFlow.lastApprovalTime
        )
        if (item.bladeFlow.assigneeName) {
          p.assigneeName = item.bladeFlow.assigneeName.replace(/,/g, ' , ')
        }
        result.push(p)
      })
      this.data = result
      this.loading = false
    },
    formatTableDate(e) {
      if (e) {
        return moment(e).format('YYYY-MM-DD HH:mm')
      } else {
        return ''
      }
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      const temp = e
      if (temp.approvalTime) {
        ;[temp.startTime, temp.endTime] = temp.approvalTime
        delete temp.approvalTime
      }
      // if (temp.createTime) {
      //   [temp.startCreateTime, temp.endCreateTime] = temp.createTime
      //   delete temp.createTime
      // }
      this.query = temp
      this.page.currentPage = 1
      await this.onLoad(this.page, temp)
      done()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    // 分页更改
    onPageChange(e) {
      console.log(e, 'onPageChange')
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    handleStepChange(row) {
      this.processId = row.id
      this.formId = row.formId

      let variables = row.bladeFlow.variables || {}
      let option = variables.option || null
      if (!option) {
        option = row.configuration || '{}'
        this.loading = true
        applyAPI.detail({ id: row.id }).then((res) => {
          this.loading = false
          const { data } = res.data
          variables = data.map || {}
          const parseOption = JSON.parse(option)
          this.stepMethodKey = parseOption.component || 'viewPage'
          const parmasArr = parseOption.params || []
          const parmas = { processId: this.processId }
          parmasArr.forEach((item) => {
            parmas[item.key] = this[item.value] || variables[item.value]
          })
          this.componentParams = parmas
          this.drawerShow = true
        })
      } else {
        const parseOption = JSON.parse(option)
        this.stepMethodKey = parseOption.component || 'viewPage'
        const parmasArr = parseOption.params || []
        const parmas = { processId: this.processId }
        parmasArr.forEach((item) => {
          parmas[item.key] = this[item.value] || variables[item.value]
        })
        this.componentParams = parmas
        this.drawerShow = true
      }

      this.rowData = row || {}
    },
    findData(key) {
      let res = {}
      if (this.processInstanceId) {
        res =
          this.data.find(
            (o) => o.processInstanceId === this.processInstanceId
          ) || {}
      } else {
        res = this.data.find((o) => o.id === this.rowData.id) || {}
      }
      return res[key]
    },
  },
}
</script>

<style lang="scss" scoped>
.myApplication-list {
  position: relative;
}
</style>
